import React from "react";
import {
  Heart,
  Shield,
  Calendar,
  GraduationCap,
  Gift,
  X,
} from "lucide-react";

const BenefitsModal = ({
  t,
  theme,
  currentTheme,
  showBenefitsModal,
  setShowBenefitsModal,
}) => {
  const benefits = [
    {
      name: t("medicalInsurance"),
      status: t("active"),
      icon: Heart,
      coverage: t("fullFamily"),
      //value: t('comprehensiveCoverage'),
      description: t("comprehensiveCoverage"),
    },
    {
      name: t("socialInsurance"),
      status: t("active"),
      icon: Shield,
      coverage: t("govMandated"),
      //value: "29.75%",
      description: t("pensionCoverage"),
    },
    {
      name: t("annualLeave"),
      status: "21 " + t("daysRemaining"),
      icon: Calendar,
      coverage: t("paidTimeOff"),
      //value: "21 " + t('daysRemaining'),
      description: t("annualVacation"),
    },
    {
      name: t("training"),
      status: t("available"),
      icon: GraduationCap,
      coverage: t("professionalGrowth"),
      //value: t('companySponsored'),
      description: t("profDevelopment"),
    },
  ];


  return (
    <>
      {/* Benefits Info Modal */}
      {showBenefitsModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            padding: "20px",
            animation: "fadeIn 0.2s ease-out",
          }}
        >
          {/* Backdrop */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0, 0, 0, 0.5)",
              backdropFilter: "blur(4px)",
              WebkitBackdropFilter: "blur(4px)",
              animation: "fadeIn 0.2s ease-out",
            }}
            onClick={() => setShowBenefitsModal(false)}
          />

          {/* Modal Content */}
          <div
            style={{
              position: "relative",
              zIndex: 10000,
              width: "min(720px, 100%)",
              maxHeight: "85vh",
              background: currentTheme.colors.inputBackground,
              borderRadius: "16px",
              boxShadow:
                theme === "dark"
                  ? "0 20px 60px rgba(0, 0, 0, 1.6), 0 0 0 1px rgba(255, 255, 255, 0.1)"
                  : "0 20px 60px rgba(0, 0, 0, 1.15), 0 0 0 1px rgba(0, 0, 0, 0.05)",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              animation: "slideUp 0.3s ease-out",
              scrollbarWidth: "none", // للـ Firefox
              msOverflowStyle: "none", // للـ IE و Edge
              WebkitOverflowScrolling: "touch", // للـ iOS
              scrollbarWidth: "none", // للـ Firefox
              msOverflowStyle: "none", // للـ IE و Edge
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "24px 24px 20px",
                borderBottom: `1px solid ${
                  theme === "dark"
                    ? "rgba(255, 255, 255, 0.1)"
                    : "rgba(0, 0, 0, 0.08)"
                }`,
                background:
                  theme === "dark"
                    ? "linear-gradient(to bottom, rgba(255, 255, 255, 0.03), transparent)"
                    : "linear-gradient(to bottom, rgba(0, 0, 0, 0.02), transparent)",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "20px",
                  fontWeight: "700",
                  color: currentTheme.colors.textPrimary,
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "10px",
                    background: `${currentTheme.colors.primary}15`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Gift size={20} color={currentTheme.colors.primary} />
                </div>
                {t("benefitsPackage")}
              </h3>

              <button
                onClick={() => setShowBenefitsModal(false)}
                style={{
                  background:
                    theme === "dark"
                      ? "rgba(255, 255, 255, 0.05)"
                      : "rgba(0, 0, 0, 0.04)",
                  border: "none",
                  cursor: "pointer",
                  width: "36px",
                  height: "36px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: currentTheme.colors.textSecondary,
                  transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background =
                    theme === "dark"
                      ? "rgba(255, 255, 255, 0.1)"
                      : "rgba(0, 0, 0, 0.08)";
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    theme === "dark"
                      ? "rgba(255, 255, 255, 0.05)"
                      : "rgba(0, 0, 0, 0.04)";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <X size={20} />
              </button>
            </div>

            {/* Content */}
            <div
              style={{
                padding: "24px",
                overflowY: "auto",
                flex: 1,
                scrollbarWidth: "none", // للـ Firefox
                msOverflowStyle: "none", // للـ IE و Edge
                WebkitOverflowScrolling: "touch", // للـ iOS
                scrollbarWidth: "none", // للـ Firefox
                msOverflowStyle: "none", // للـ IE و Edge
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "16px",
                }}
              >
                {benefits.map((b, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      gap: "16px",
                      alignItems: "flex-start",
                      padding: "16px",
                      borderRadius: "12px",
                      background:
                        theme === "dark"
                          ? "rgba(255, 255, 255, 0.03)"
                          : "rgba(0, 0, 0, 0.02)",
                      border: `1px solid ${
                        theme === "dark"
                          ? "rgba(255, 255, 255, 0.06)"
                          : "rgba(0, 0, 0, 0.06)"
                      }`,
                      transition: "all 0.2s ease",
                      cursor: "default",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        theme === "dark"
                          ? "rgba(255, 255, 255, 0.05)"
                          : "rgba(0, 0, 0, 0.03)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        theme === "dark"
                          ? "0 8px 24px rgba(0, 0, 0, 0.3)"
                          : "0 8px 24px rgba(0, 0, 0, 0.08)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background =
                        theme === "dark"
                          ? "rgba(255, 255, 255, 0.03)"
                          : "rgba(0, 0, 0, 0.02)";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    {/* Icon */}
                    <div
                      style={{
                        minWidth: "48px",
                        width: "48px",
                        height: "48px",
                        borderRadius: "12px",
                        background: `linear-gradient(135deg, ${currentTheme.colors.primary}25, ${currentTheme.colors.primary}15)`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: currentTheme.colors.primary,
                        boxShadow: `0 4px 12px ${currentTheme.colors.primary}20`,
                      }}
                    >
                      <b.icon size={22} strokeWidth={2.5} />
                    </div>

                    {/* Content */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {/* Title & Status */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          gap: "12px",
                          marginBottom: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <strong
                          style={{
                            fontSize: "15px",
                            fontWeight: "700",
                            color: currentTheme.colors.textPrimary,
                          }}
                        >
                          {b.name}
                        </strong>

                        <span
                          style={{
                            padding: "4px 12px",
                            borderRadius: "8px",
                            background: `${currentTheme.colors.success}18`,
                            color: currentTheme.colors.success,
                            fontWeight: "600",
                            fontSize: "12px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            border: `1px solid ${currentTheme.colors.success}30`,
                          }}
                        >
                          {b.status}
                        </span>
                      </div>

                      {/* Coverage */}
                      <div
                        style={{
                          fontSize: "14px",
                          color: currentTheme.colors.textSecondary,
                          marginBottom: "6px",
                          fontWeight: "600",
                        }}
                      >
                        {b.coverage}
                      </div>

                      {/* Description */}
                      <div
                        style={{
                          fontSize: "13px",
                          color: currentTheme.colors.textMuted,
                          lineHeight: "1.5",
                        }}
                      >
                        {b.description}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Animation Styles */}
          <style>{`
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      
      @keyframes slideUp {
        from {
          opacity: 0;
          transform: translateY(20px) scale(0.98);
        }
        to {
          opacity: 1;
          transform: translateY(0) scale(1);
        }
      }
      
      /* Custom Scrollbar */
      div[style*="overflowY: auto"]::-webkit-scrollbar {
        width: 8px;
      }
      
      div[style*="overflowY: auto"]::-webkit-scrollbar-track {
        background: transparent;
      }
      
      div[style*="overflowY: auto"]::-webkit-scrollbar-thumb {
        background: ${
          theme === "dark" ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)"
        };
        borderRadius: 10px;
      }
      
      div[style*="overflowY: auto"]::-webkit-scrollbar-thumb:hover {
        background: ${
          theme === "dark" ? "rgba(255, 255, 255, 0.3)" : "rgba(0, 0, 0, 0.3)"
        };
      }
    `}</style>
        </div>
      )}
    </>
  );
};

export default BenefitsModal;